import type { RegistryEntry, UiOptionSelect } from '../types';
import { clampTo } from '../../tools';

export const xaiConfigs: Record<string, RegistryEntry> = {
  'grok-imagine-image-2.0': {
    options: [
      {
        key: 'quality',
        label: 'Gen Quality',
        type: 'select',
        options: [
          { label: 'Low', value: 'low' },
          { label: 'Medium', value: 'medium' },
        ],
        default: 'medium',
        group: 'basic',
      } as UiOptionSelect,
    ],
    toProviderOptions: (ui) =>
      ({
        quality: clampTo(
          ui.quality || 'medium',
          ['low', 'medium'] as const,
          'medium',
        ),
      }) as unknown as Record<string, Record<string, any>>,
  },
};
